module.exports = {
  validate: {
    emailBlank: 'Please input your email!',
    passwordBlank: 'Please input your password!',
  },
  email: 'Email',
  password: 'Password',
  loginBtn: 'LOGIN',
  signIn: 'SIGN IN NOW',
  forget: 'Forgot password?',
};
